import endpoints from '@/api/endpoints';
import { http, HttpResponse } from 'msw';
import { StatementHistory } from '@/interfaces/statement';

const API_BASE_URL = endpoints.baseURL;

// ── Mock data ─────────────────────────────────────────────────────────────
export const mockStatements: StatementHistory[] = [
  {
    id: '6ed25d5a-fecf-479a-95a1-894eb38e2cf9',
    accountId: '0b679eab-db5e-4cb4-b07e-2a8185bb2757',
    startDate: '2026-08-01T00:00:00Z',
    endDate: '2026-08-31T23:59:59.999999Z',
    createdAt: '2026-09-01T02:15:09.390572Z',
    file: {
      name: 'f7a27b1a-999a-42dc-8b28-28c9fd864d86.pdf',
      originalFilename: 'statement-2026-08.pdf',
      parentDirectory: '2026-09',
      size: 173.99512,
      type: 'application/pdf',
    },
    expiryDate: null,
    autoGenerated: true,
    downloadCount: 0,
  },
  {
    id: 'b1d0c47e-5c8a-4f2e-9a31-6f0f5d2b7c14',
    accountId: '0b679eab-db5e-4cb4-b07e-2a8185bb2757',
    startDate: '2026-07-01T00:00:00Z',
    endDate: '2026-07-31T23:59:59.999999Z',
    createdAt: '2026-08-01T02:14:41.118204Z',
    file: {
      name: '2c9be4d1-3a77-41bd-8f52-7d1c9ab0e6f3.pdf',
      originalFilename: 'statement-2026-07.pdf',
      parentDirectory: '2026-08',
      size: 168.42871,
      type: 'application/pdf',
    },
    expiryDate: null,
    autoGenerated: true,
    downloadCount: 2,
  },
  {
    id: 'd4f8a90b-77e1-42c6-b0d5-1e3c8f6a24b9',
    accountId: '69474838-f0cd-497d-b21b-d8994e1034d0',
    startDate: '2026-08-01T00:00:00Z',
    endDate: '2026-08-31T23:59:59.999999Z',
    createdAt: '2026-09-01T02:15:12.740913Z',
    file: {
      name: '9a1e5c73-8b24-4de9-95f1-0c7b2d84f6a1.pdf',
      originalFilename: 'statement-2026-08.pdf',
      parentDirectory: '2026-09',
      size: 152.07324,
      type: 'application/pdf',
    },
    expiryDate: null,
    autoGenerated: true,
    downloadCount: 0,
  },
];

export const buildStatementHistory = (overrides: Partial<StatementHistory> = {}): StatementHistory => ({
  id: '6ed25d5a-fecf-479a-95a1-894eb38e2cf9',
  accountId: 'acc-001',
  startDate: '2026-07-01T00:00:00Z',
  endDate: '2026-07-31T23:59:59.999999Z',
  createdAt: '2026-08-03T16:03:09.390572Z',
  file: {
    name: 'f7a27b1a-999a-42dc-8b28-28c9fd864d86.pdf',
    originalFilename: 'statement-2026-07.pdf',
    parentDirectory: '2026-08',
    size: 173.99512,
    type: 'application/pdf',
  },
  expiryDate: null,
  autoGenerated: true,
  downloadCount: 0,
  ...overrides,
});

export const statementHistoriesPage = (data: StatementHistory[]) => ({
  data,
  number: 0,
  numberOfElements: data.length,
  totalElements: data.length,
  totalPages: data.length ? 1 : 0,
  size: 5,
  sort: 'createdAt,desc',
});

const buildPdfBlob = (label: string) => {
  const content = `%PDF-1.4
1 0 obj<</Type/Catalog/Pages 2 0 R>>endobj
2 0 obj<</Type/Pages/Kids[3 0 R]/Count 1>>endobj
3 0 obj<</Type/Page/Parent 2 0 R/MediaBox[0 0 320 130]/Contents 4 0 R/Resources<</Font<</F1 5 0 R>>>>>>endobj
4 0 obj<</Length 80>>stream
BT /F1 12 Tf 20 70 Td (Releve de compte) Tj 0 -20 Td (${label}) Tj ET
endstream endobj
5 0 obj<</Type/Font/Subtype/Type1/BaseFont/Helvetica>>endobj
trailer<</Root 1 0 R>>`;

  return new Blob([content], { type: 'application/pdf' });
};

export const statementHistoriesHandler = http.get(`${API_BASE_URL}${endpoints.getStatementHistories}`, ({ request }) => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get('page')) || 0;
  const size = Number(url.searchParams.get('size')) || 20;
  const accountId = url.searchParams.get('accountId');
  const statements = accountId ? mockStatements.filter(item => item.accountId === accountId) : mockStatements;
  const paged = statements.slice(page * size, page * size + size);

  return HttpResponse.json({
    data: paged,
    number: page,
    numberOfElements: paged.length,
    totalElements: statements.length,
    totalPages: Math.ceil(statements.length / size),
    size,
    sort: url.searchParams.get('sort'),
  });
});

export const statementDownloadHandler = http.get(`${API_BASE_URL}/transaction/statement-histories/:id/download`, ({ params }) => {
  const id = String(params.id);
  const statement = mockStatements.find(item => item.id === id);
  const fileName = statement?.file?.originalFilename ?? `statement-${id}.pdf`;

  return new HttpResponse(buildPdfBlob(fileName), {
    headers: {
      'Content-Type': 'application/pdf',
      'Content-Disposition': `attachment; filename=${fileName}`,
    },
  });
});

export const statementsHandlers = [statementHistoriesHandler, statementDownloadHandler];
